export * from '../../../components/FooterV2/FooterSocial/FooterSocial';
